/*
 * @Description: 调取天喻云网关地址(正式线、测试线)
 * @Author: luozhao
 * @Date: 2021-02-01 14:26:54
 */

import axios from "axios";
import {getAccessToken} from '@/utils-khfw/assbeToken';
import {getToken} from '@/utils-khfw/token.serviceLocal';
// import bigMindAccessToken from '@/utils/bigMindAccessToken.js';
import Messages from "@/utils/message.js";
/* 实例化axios */
let AxiosInstance = axios.create({});

/* 实例对象默认配置 */
AxiosInstance.defaults.responseType = "json"; // 返回数据类型json
AxiosInstance.defaults.timeout = 20000; // 超时时间
/**
 * 请求拦截器 accessToken userToken
 */
AxiosInstance.interceptors.request.use(
	async (config) => {
		let url = config.url;
		// 针对大数据的接口没有测试环境的兼容处理
		config.baseURL=url.includes('dataservice')?'https://gateway.tianyuyun.com':sessionStorage.getItem("linktype") =="pre"?'https://assbe-pre.huijiaoyun.com':process.env.VUE_APP_API_URL
		if (config.method.toLowerCase() === 'post') config.data = config.data || {};
		// 测试线网关和机构注册的接口不需要传userToken
		if( process.env.VUE_APP_MODE !== 'test' && !url.includes('organization')){
			const userToken = await getToken();
			config.url += `${url.indexOf('?') >= 0 ? '&' : '?'}userToken=${userToken}`;
		}
	    //机构注册的接口需要携带Ty-Appid (appid)，Ty-Timestamp(时间戳)！
		if(url.includes('organization')){
			config.headers['Ty-Appid'] = "5txk2cf684cj6x7b28r6darkt38tr4jw";
			config.headers['Ty-Timestamp'] =  new Date().getTime();
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

/**
 * 响应拦截器
 */
AxiosInstance.interceptors.response.use(
	async (response) => {
		// 自定义返回码 作不同处理
		if(!response.data){
			  Messages.error({
				message: "请求失败,请重新登录",
				duration: 2 * 1000,
				center: true,
				offset: 120,
			  });
		}
		return response.data;
	},
	(err) => {
		if (err && err.response) {
			switch (err.response.status) {
				case 400:
					this.$message({
						type: "error",
						message: "请求错误",
					  });
					break;
				case 401:
					this.$message({
						type: "error",
						message: "未授权，请登录",
					  });
					break;
				case 403:
					this.$message({
						type: "error",
						message: "拒绝访问",
					  });
					break;
				case 404:
					this.$message({
						type: "error",
						message: `请求地址出错: ${err.response.config.url}`,
					  });
					break;
				case 408:
					this.$message({
						type: "error",
						message: "请求超时",
					  });
					break;
				case 500:
					this.$message({
						type: "error",
						message: "服务器内部错误",
					  });
					break;
				case 501:
					this.$message({
						type: "error",
						message: "服务未实现",
					  });
					break;
				case 502:
					this.$message({
						type: "error",
						message: "网关错误",
					  });
					break;
				case 503:
					this.$message({
						type: "error",
						message: "服务不可用",
					  });
					break;
				case 504:
					this.$message({
						type: "error",
						message: "网关超时",
					  });
					break;
				case 505:
					this.$message({
						type: "error",
						message: "HTTP版本不受支持",
					  });
					break;
				default:
					this.$message({
						type: "error",
						message: "登录超时，请重新登录",
					  });
					break;
			}
		}
		return Promise.reject(err);
	},
);

export default AxiosInstance;
